import React, { useCallback, useEffect, useState } from "react";
import { Card, Col, Table } from "react-bootstrap";
import PageTitle from "../layouts/PageTitle";
import { useNavigate } from "react-router-dom";
import { Badge, Dropdown } from "react-bootstrap";

import toast from "react-hot-toast";
import Lottie from "lottie-react";
import animationData from "../../images/loding.json";
import moment from "moment";
import Pagination from "../components/Pagination";
import {
  blockUser,
  getUserList,
} from "../../services/UserServices/UserService";
import S3Image from "../components/S3Image";
import ConfirmationDeleteAccount from "../components/Modal/ConfirmationDeleteAccount";
import debounce from "lodash/debounce";

export default function JobPosting(props) {
  const navigate = useNavigate();
  const [deleteAccount, setDeleteAccount] = useState(false);
  const [loader, setLoader] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [jobId, setJobId] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  //  const [totalPages, setTotalPages] = useState(0);
  const [search, setSearch] = useState("");
  const [sortBy,setSortBy]=useState("");
  const [isBlocked, setIsBlocked] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);


  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );

  async function handleTableList() {
    setLoader(true);
    try {
      const res = await getUserList(currentPage, 10, search);
      setTableData(res?.data?.data?.users);
      setTotalItems(res?.data?.data.count);
    
      
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoader(false);
    }
  }

  async function handleBlockComponent() {
    setActionLoading(true);
    try {
      await blockUser({ userId: jobId, isBlocked });
      handleTableList();
      setDeleteAccount(false);
      toast.success("User blocked successfully");
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setActionLoading(false);
    }
  }

  const handleTableListDebounced = useCallback(
    debounce(() => {
      handleTableList();
    }, 400),
    [search,currentPage]
  );


 
  // useEffect to trigger search whenever input changes
  useEffect(() => {
    handleTableListDebounced();

    // Cleanup debounce on unmount or next effect
    return () => handleTableListDebounced.cancel();
  }, [search, currentPage]);

  async function handleUnblockComponent(id) {
    setActionLoading(true);
    try {
      await blockUser({ userId: id, isBlocked: false });
      handleTableList();
      setDeleteAccount(false);
      toast.success("User unblocked successfully");
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setActionLoading(false);
    }
  }

  const totalPages = Math.ceil(totalItems / itemsPerPage);
 

  if (!!tableData && tableData?.length === 0 && !loader) {
    <div className="justify-content-center d-flex my-5 ">
      Sorry, Data Not Found!
    </div>;
  }
 

 

  return (
    <div className="mt-5">




 
    <div class="text-end">
       <label for="sort" class="me-2 fw-bold " style={{color:"maroon"}}>Sort By:</label> 
       <select id="sort"  style={{ color: "maroon", backgroundColor: "wheat" ,border:0}} class="form-select d-inline-block w-auto mb-2" value={sortBy} onChange={(e)=>setSortBy(e.target.value)}> 
      <option style={{color:"maroon"}} value="">default</option>
       <option value="name">name</option> <option value="createdAt">created at</option> </select>
        </div>

      <div className="pb-2 d-flex justify-content-between">
        <input
          type="text"
          style={{ borderRadius: "0.5rem", width: "100%" }}
          className="form-control inpp"
          placeholder="Search name, phone-number"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <Col>
        {loader ? (
          <div>
            <Lottie
              style={{
                height: "200px",
                marginTop: "45px",
                padding: "30px",
              }}
              animationData={animationData}
            />
          </div>
        ) : (
          !!tableData &&
          tableData.length > 0 && (
            <Card>
              <Card.Body>
                <Table responsive>
                  <thead style={{ color: "#A60000" }}>
                    <tr>
                      <th>
                        <strong>S.NO</strong>
                      </th>

                      <th>
                        <strong>  Name</strong>
                      </th>
                      <th>
                        <strong>User Type</strong>
                      </th>
                      <th>
                        <strong>Phone Number</strong>
                      </th>

                      <th>
                        <strong>Created At</strong>
                      </th>

                      <th>
                        <strong>Status</strong>
                      </th>
                      <th>
                        <strong>Action</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData?.map((tension, index) => (
                      <tr style={{ color: "#A60000" }} key={tension?._id}>
                        <td>{index + 1 + currentPage * itemsPerPage}</td>
                    
                        <td>
                          <span className="w-space-no">
                            {" "}
                            {tension?.hostName ? tension?.hostName : "User!"}
                          </span>
                        </td>
                        <td>
                          <span
                            className={`w-space-no`}
                          >
                            {tension?.hostSide ? tension?.hostSide : "Bride"}
                          </span>
                        </td>
                        <td>
                          <span className="w-space-no">
                            {tension?.countryCode} {tension?.phoneNumber}
                          </span>
                        </td>
                        <td>
                          <span className="w-space-no">
                            {new Date(tension?.createdAt).toLocaleDateString(
                              "en-IN",
                              {
                                day: "2-digit",
                                month: "long",
                                year: "numeric",
                              }
                            )}
                          </span>
                        </td>
                        <td>
                          {tension?.isBlocked ? (
                            <Badge bg="" className="badge-danger">
                              Blocked
                            </Badge>
                          ) : (
                            <Badge bg="" className="badge-success">
                              Enable
                            </Badge>
                          )}
                        </td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="info light"
                              className="light sharp btn btn-info i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  navigate(`/user-details/${tension._id}`, {
                                    state: { tension },
                                  });
                                  //  navigate(`/user-details/${tension._id}`)
                                }}
                              >
                                View
                              </Dropdown.Item>

                              {/* ✅ Block / Unblock Option */}
                              <Dropdown.Item
                                onClick={() => {
                                  if (tension?.isBlocked) {
                                    handleUnblockComponent(tension?._id);
                                    setIsBlocked(false);
                                  } else {

                                    setDeleteAccount(true);
                                    setJobId(tension?._id);
                                    setIsBlocked(true);
                                  }
                                }}
                              >
                                {tension?.isBlocked ? "Unblock" : "Block"}
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                {tableData?.length !== 0 && (
                  <div className="card-footer clearfix">
                    <div className="d-flex justify-content-between align-items-center">
                      <div
                        className="dataTables_info"
                        style={{ color: "#A60000" }}
                      >
                        Page {currentPage * itemsPerPage + 1} to{" "}
                        {totalItems > (currentPage + 1) * itemsPerPage
                          ? (currentPage + 1) * itemsPerPage
                          : totalItems}{" "}
                        of {totalItems} entries
                      </div>
                      <div
                        className="d-flex align-items-center"
                        style={{ gap: "10px" }}
                      >
                        <Pagination
                          pageCount={totalPages}
                          pageValue={currentPage}
                          setPage={setCurrentPage}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </Card.Body>
            </Card>
          )
        )}
      </Col>
      <ConfirmationDeleteAccount
        show={deleteAccount}
        onHide={() => setDeleteAccount(false)}
        onDelete={handleBlockComponent}
        type="user"
      />
    </div>
  );
}




 